module.exports = __webpack_public_path__ + "static/media/book-icon.c19abea3.png";